<template>
  <div class="AddressSearchComponent">
    <div class="flex drug_select_block">
      <div class="maxWidth">
        <v-select ref="select" v-model="record"
                  @keypress.enter.native.prevent=""
                  label="title"
                  placeholder="Адрес доставки"
                  :filterable="false"
                  class="search_input"
                  @input="selectDrug"
                  :appendToBody="true"
                  @keypress.native="fastSearchCheck"
                  :options="suggestions"
                  @search:focus="fillSearch"
                  @search="searchDrug">
          <template slot="no-options">
            введите адрес доставки..
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center text-wrap">
              {{ option.title }}
              <!--              <template v-if="option && option.title">-->
              <!--                {{ option && option.title || '' }} {{ showDetails !== false && option.veshchestvo ? '::' + option.veshchestvo : '' }}-->
              <!--              </template>-->
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="text-wrap">
              {{ option.title }}
            </div>
            <!--            <template v-if="option && option.title">-->
            <!--              {{ option.title || '' }} {{ showDetails !== false && option.veshchestvo ? ':: ' + option.veshchestvo : '' }} {{ showId && option.id ? '(' + option.id + ')' : '' }}-->
            <!--            </template>-->
          </template>
        </v-select>
      </div>
      <div v-if="record" class="map_tooltip_btn">
        <v-popover
          :auto-hide="true"
          Class="h-100"
          popoverClass="order_address_map_popover"
          popoverInnerClass="order_address_map_popover_inner"
          :delay='{ show: 100, hide: 500 }'
        >
          <button class="btn btn-outline-info mr-1 h-100"><i
            class="icon-fa icon-fa-map-marker"/>
          </button>
          <template slot="popover">
            <AddressMap :orderId="$editNewOrder?.id" :cityId="$editNewOrder.city_id" :address="record?.title"/>
          </template>
        </v-popover>
        <!--        <a class="btn btn-outline-info map_link" target="_blank"-->
        <!--           :href='`https://yandex.ru/maps?text=${record?.title}&z=11`'>-->
        <!--          <i class="icon-fa icon-fa-map-marker"/>-->
        <!--        </a>-->
      </div>
    </div>
  </div>

</template>

<script>

import vSelect from 'vue-select';
import VTooltip from 'v-tooltip'
import api from '@/api'
import AddressMap from "@/components/map/AddressMap.vue";

export default {
  components: {
    AddressMap,
    vSelect,
    VTooltip,
  },
  props: [
    'onSelect', 'selected'
  ],
  data() {
    return {
      drugInfoLoading: false,
      localDrugData: null,
      record: null,
      suggestions: [],
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters["orders/editNewOrder"];
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
  },
  mounted() {
    if (this.selected) {
      this.record = {title: this.selected}
    }
  },
  methods: {
    fillSearch(e) {
      if (this.$editNewOrder && this.$editNewOrder.city_id) {
        this.$refs.select.search = this.$AllCities[this.$editNewOrder.city_id] && this.$AllCities[this.$editNewOrder.city_id].name + ' ';
      }
    },
    searchFocus(e) {
      console.log(e);
      document.querySelectorAll('.vs__search').forEach((i) => {
        // console.log(i);
        // i.scrollLeft = i.scrollWidth;
        // let val = i.value;
        // i.value = ''
        // i.value = val;
      })
      if (this.selected) {
        this.$refs.select.search = this.selected;
      }
    },
    fastSearchCheck(e) {
      // console.log(e);
      // if ()
      // console.log(this.$refs.select.search);
      // selectDrug()
    },
    selectDrug(e) {
      console.log('selected', e);
      if (this.onSelect) {
        this.onSelect(e);
      }
    },
    searchDrug(search, loading) {
      if (!search || search.length < 3) return;
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce(async (loading, search, vm) => {
      if (!search) return;
      vm.suggestions = [];
      const {data} = await api.index('orders/getAddressSuggest?q=' + encodeURIComponent(search));
      // console.log(data);
      let sugg = [];
      if (data.success && data.suggestions && data.suggestions.length) {
        // vm.suggestions = data.suggestions, {title: search}];
        sugg = data.suggestions;
      }
      // if (!sugg.find((s) => s.title === search)) {
      //   sugg.push({title: search});
      // }
      vm.suggestions = sugg;
      loading(false);
    }, 1000),
  }
}

</script>

<style>
.AddressSearchComponent .vs__search::placeholder {
  color: #908c8c;
}
</style>

<style scoped>
.map_link {
  height: 100%;
  display: flex;
  align-items: center;
}

@media (max-width: 520px) {
  .drug_select_block {
    flex-direction: column;
  }
}

.drugSearchComponent {
  min-width: 250px;
}

.icon-info {
  text-align: center;
}

.sm-btn {
  height: 34px !important;
}

.v-select {
  font-size: 16px;
}

.wd-70 {
  width: 70px;
}

.maxWidth {
  width: 100%;
  /*min-width: 450px;*/
  /*width: 70%;*/
  text-align: left;
}
</style>

<style>
.map_tooltip_btn .trigger,
.map_tooltip_btn .v-popover {
  height: 100%;
}

.vs--single .vs__selected {
  max-width: 90%;
}

.vs__dropdown-toggle {
  border-radius: 0;
  /*height: 35px;*/
}

.tooltip {
  //z-index: 990000 !important;
}

.tooltip-inner {
  background: white !important;
  color: #333 !important;
  max-width: max-content !important;
}

.drugSearchComponent .popover a {
  color: #007dcc;
}

.drugSearchComponent .popover {
  max-width: max-content !important;
}

.drugSearchComponent .vs__dropdown-toggle {
  height: auto !important;
  max-height: 117px;
  min-height: 38px;
  border-radius: 0;
}

.tooltip-inner p {
  text-align: left;
}

.tooltipBlock p {
  margin-bottom: 2px;
}

</style>
